import { locationBrandingSummaryDTOSchema, locationKioskBrandingViewDTOSchema, organizationKioskBrandingDTOSchema, } from '@instanexus/contracts';
import { z } from 'zod';
import { dataEnvelopeSchema, listEnvelopeSchema, WEB_API_PREFIX } from '../transport.js';
const brandingSchema = dataEnvelopeSchema(organizationKioskBrandingDTOSchema);
const brandingLocationsSchema = listEnvelopeSchema(locationBrandingSummaryDTOSchema);
const overrideSchema = dataEnvelopeSchema(locationKioskBrandingViewDTOSchema);
const BRANDING_PATH = `${WEB_API_PREFIX}/branding`;
const LOGO_PATH = `${WEB_API_PREFIX}/branding/logo`;
function overridePath(locationId) {
    return `${WEB_API_PREFIX}/locations/${encodeURIComponent(locationId)}/branding/override`;
}
export function createBrandingResource(transport) {
    return {
        async get() {
            const envelope = await transport.request({ path: BRANDING_PATH, schema: brandingSchema });
            return envelope.data;
        },
        async update(input) {
            const envelope = await transport.request({
                method: 'PUT',
                path: BRANDING_PATH,
                schema: brandingSchema,
                body: input,
            });
            return envelope.data;
        },
        async uploadLogo(file, contentType) {
            const envelope = await transport.requestUpload({
                path: LOGO_PATH,
                schema: brandingSchema,
                contentType,
                body: file,
            });
            return envelope.data;
        },
        async removeLogo() {
            await transport.request({ method: 'DELETE', path: LOGO_PATH, schema: z.undefined() });
        },
        async getLogo() {
            return transport.requestBlob({ path: LOGO_PATH, accept: 'image/*' });
        },
        async listLocations(params = {}) {
            return transport.request({
                path: `${BRANDING_PATH}/locations`,
                schema: brandingLocationsSchema,
                query: { page: params.page, pageSize: params.pageSize },
            });
        },
        async createLocationOverride(locationId) {
            const envelope = await transport.request({
                method: 'PUT',
                path: overridePath(locationId),
                schema: overrideSchema,
            });
            return envelope.data;
        },
        async removeLocationOverride(locationId) {
            await transport.request({ method: 'DELETE', path: overridePath(locationId), schema: z.undefined() });
        },
    };
}
//# sourceMappingURL=branding.js.map